angular
.module( 'ribytRsvpApp' )
.directive( 'airByt', function ( $sessionStorage, $rootScope, $state ) {
    return {
        'restrict': 'E',
        'scope': {
            'currentByt': '@',
            'previousConfirmation': '@',
            'isTimeFormat24': '@'
        },
        'templateUrl': 'views/directives/itinerary/airByt.html',
        'link': function ( scope, element, attrs ) {
            var byt = JSON.parse( scope.currentByt );
            var newByt = {};
            scope.preview = $rootScope.preview;

            _.each( byt, function ( b, key ) {
                newByt[key] = b;
            } );
            scope.byt = newByt;

            scope.pdfView = _.get( $sessionStorage, 'pdfView', false );
                // remove the confirmation code if it's the same as the previous leg
            if ( scope.byt.bytDetails.legs.confirmation === scope.previousConfirmation ) {
                delete scope.byt.bytDetails.legs.confirmation;
            }
        }
    };
} );
